import { render, staticRenderFns } from "./portfolio-panel.vue?vue&type=template&id=e6a92a30&"
import script from "./portfolio-panel.ts?vue&type=script&lang=ts&"
export * from "./portfolio-panel.ts?vue&type=script&lang=ts&"
import style0 from "./portfolio-panel.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports